import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

export async function fetchDownloadVariations(assetId: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/download_variations/${assetId}`;
  const response = await get(requestUrl);
  return response;
}
